import React, { useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import {
	BrowserRouter,
	Switch,
	Route,
	useLocation
} from 'react-router-dom'
import ReactGA from 'react-ga'
import HttpNotifier from 'components/http-notifier'
import Http from 'components/http'
import Notifications from 'components/notifications'
import Messages from 'components/messages'
import MessageTray from 'components/message-tray'
import {Trans} from 'components/trans'
import PageNotFound from './page-not-found'
import Header from './header'
import Footer from './footer'
import Home from './home'
import Login from './login'
import Profile from './profile'
import Members from './members'
import NewsPage from './news-page'
import FeedPage from './feed-page'
import DynamicContent from './dynamiccontent'
import ChatPage from './chat-page'
import ChatSocket from './chat-socket'
import model from 'components/model'
import EventsPage, {EventPage} from './events-page'

hp.store.followers = model(hp.store.followers);


ReactGA.initialize(hp.store.config.ga);

function usePageViews() {
	if (!hp.store.config.ga) {
		return
	}
	const location = useLocation()
	useEffect(
		() => {
			/*
			ReactGA.initialize(hp.store.config.ga, {
				gaOptions: {
					siteSpeedSampleRate: 100,
					userId: hp.store.uid
				}
			})
			*/
			ReactGA.pageview(location.pathname + location.search);
			/*
			window.gtag('config', 'UA-207687489-2', {
				page_title: location.pathname,
				page_path: location.pathname
			})
			*/
		},
		[location]
	)
}

function App() {
	usePageViews()
	return (
		<div>
			<Messages />
			<Header />
			<Switch>
				<Route exact path='/'><Home /></Route>
				<Route path='/home/index'><Home /></Route>
				<Route path='/home/login'><Login /></Route>
				<Route path='/home/profile/:uid?' component={ Profile } />
				<Route path='/home/members' component={ Members } />
				<Route path='/home/news/:nid?/:type?' component={ NewsPage } />
				<Route path='/home/feed/:fid?' component={ FeedPage } />
				<Route path='/home/infoteca/:catid?' component={ DynamicContent } />
				<Route exact path='/home/events' component={ EventsPage } />
				<Route path='/home/event/:eid/:titled?' component={ EventPage } />
				<Route path='/home/chat/:uid?' component={ ChatPage } />
				<Route path='*'><PageNotFound /></Route>
			</Switch>
			<Footer />
			<MessageTray />
		</div>
	)
}

window.http = Http;
window.httpNotifier = new HttpNotifier();
window.messages = new Notifications();
window.notifications = new Notifications(8000);
window.React = React;

if (hp.store.uid && hp.store.chat_active == 1) {
	hp.store.chatSocket = new ChatSocket();
}

const appelem = document.getElementById('app');
if (appelem) {
	const root = createRoot(appelem)
	root.render(
		<BrowserRouter>
			<App />
		</BrowserRouter>,
		appelem
	)
}
